import type { Translations } from "../types";

const ta: Translations = {
  "meta.title": "நாடுவாரியான கிளிக் வரைபடம்",
  "meta.description":
    "ஊடாடும் உலக வரைபடம்: ஒவ்வொரு நாட்டிற்கும் இலவச கிளிக்குகள் மற்றும் Stripe, PayPal மற்றும் Buy Me a Coffee மூலம் கட்டண ஆதரவு.",

  "app.title": "நாடுவாரியான கிளிக் வரைபடம்",

  "map.intro":
    "ஒரு நாட்டிற்கு இலவச வாக்கு அளிக்க வரைபடத்தில் அதைக் கிளிக் செய்யவும், அல்லது அதற்கு நிதி ஆதரவு அனுப்பவும் - இரண்டும் கீழே உள்ள ஒருங்கிணைந்த தரவரிசைப் பட்டியலில் கணக்கிடப்படும். இந்த வரைபடம் இந்த ஆப்பிற்குள் உள்ள ஆதரவை மட்டுமே காட்டுகிறது, உண்மையான தேசிய செல்வம் அல்லது மொத்த உள்நாட்டு உற்பத்தியை அல்ல.",
  "map.verifying": "சரிபார்க்கிறது …",
  "map.confirmNotRobot": "இலவச கிளிக்குகளைச் சேர்க்கும் முன், நீங்கள் ரோபோ அல்ல என்பதை விரைவாக உறுதிப்படுத்தவும்:",
  "map.tryAgain": "மீண்டும் முயற்சிக்கவும்",
  "map.registeringClick": "கிளிக் பதிவு செய்யப்படுகிறது …",
  "map.selectedCountry": "தேர்ந்தெடுக்கப்பட்ட நாடு: {name}.",
  "map.selectFirstFeedback": "நாடு தேர்ந்தெடுக்கப்பட்டது. இலவச கிளிக் ஒன்றைச் சேர்க்க, முதலில் கீழே நீங்கள் ரோபோ அல்ல என்பதை உறுதிப்படுத்தவும்.",
  "map.verificationExpired": "சரிபார்ப்பு காலாவதியானது - நீங்கள் ரோபோ அல்ல என்பதை மீண்டும் உறுதிப்படுத்தவும்.",
  "map.slowDown": "கொஞ்சம் மெதுவாக - அடுத்த கிளிக்கிற்கு முன் சிறிது நேரம் காத்திருக்கவும்.",
  "map.clickFailed": "கிளிக்கைப் பதிவு செய்ய முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  "map.clickErrorGeneric": "கிளிக் பதிவில் பிழை.",
  "map.leaderboardHeading": "நாடுகள் தரவரிசைப் பட்டியல்",
  "map.emptySelection": "கிளிக் செய்ய அல்லது ஆதரிக்க வரைபடத்தில் ஒரு நாட்டைத் தேர்ந்தெடுக்கவும்.",
  "map.loadingData": "தரவு ஏற்றப்படுகிறது …",

  "worldmap.loadError": "வரைபடத்தை ஏற்ற முடியவில்லை.",
  "worldmap.resetZoom": "பெரிதாக்கத்தை மீட்டமை",
  "worldmap.resetButton": "⤾ மீட்டமை",
  "worldmap.loadingMap": "வரைபடம் ஏற்றப்படுகிறது …",
  "worldmap.unknownCountry": "தெரியவில்லை",
  "worldmap.ariaClicks": "{name}: {clicks} கிளிக்குகள்",
  "worldmap.tooltipClicks": "{clicks} கிளிக்குகள்",

  "legend.fewer": "குறைவான கிளிக்குகள்",
  "legend.more": "அதிக கிளிக்குகள்",

  "list.empty": "இதுவரை கிளிக்குகள் இல்லை. முதலில் நீங்களே ஆகுங்கள்!",
  "list.ariaLabel": "கிளிக் அடிப்படையில் நாடுகள் தரவரிசைப் பட்டியல்",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY அமைக்கப்படவில்லை - கட்டமைப்பிற்கு README ஐப் பார்க்கவும்.",
  "human.verificationFailedGeneric": "சரிபார்ப்பு தோல்வியடைந்தது.",
  "human.networkError":
    "சரிபார்ப்பை அடைய முடியவில்லை (நெட்வொர்க் பிழை) - VITE_SUPABASE_URL ஐயும், verify-human வரிசைப்படுத்தப்பட்டுள்ளதையும், ALLOWED_ORIGIN ஐயும் சரிபார்க்கவும்; README/NAVODILA ஐப் பார்க்கவும்.",
  "human.verificationFailedRetry": "சரிபார்ப்பு தோல்வியடைந்தது, மீண்டும் முயற்சிக்கவும்.",

  "provider.stripe": "💳 அட்டை (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "தேர்ந்தெடுக்கப்பட்ட நாடு",
  "panel.currentlyRanked": "தற்போது #{rank} தரவரிசையில் உள்ளது",
  "panel.shareCopied": "நகலெடுக்கப்பட்டது ✓",
  "panel.shareShared": "பகிரப்பட்டது ✓",
  "panel.shareButton": "🔗 பகிர்",

  "panel.tableClicks": "கிளிக்குகள்",
  "panel.tableFree": "இலவசம்",
  "panel.tablePaid": "கட்டணம் செலுத்தியது",
  "panel.rowAllTime": "எல்லா காலமும்",
  "panel.rowThisYear": "இந்த ஆண்டு",
  "panel.rowThisWeek": "இந்த வாரம்",
  "panel.rowToday": "இன்று",

  "panel.totalCombined": "மொத்த ஒருங்கிணைந்த எண்ணிக்கை:",
  "panel.totalSupport": "மொத்த ஆதரவு:",

  "panel.paymentMethod": "கட்டண முறை",
  "panel.noPaymentMethod": "தற்போது எந்த கட்டண முறையும் கிடைக்கவில்லை.",
  "panel.supportAmount": "ஆதரவுத் தொகை (EUR)",
  "panel.amountRange": "தொகை {min} மற்றும் {max} இடையே இருக்க வேண்டும்.",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "மதிப்பிடப்பட்ட கட்டண கிளிக்குகள்:",
  "panel.ratioInfo":
    "விகிதம்: {a} = {b} கிளிக்குகள் (எ.கா. {c} = {d} கிளிக்குகள்). இது கட்டணத்திற்கு முன் ஒரு மதிப்பீடு மட்டுமே - இறுதி கிளிக் எண்ணிக்கை எப்போதும் உண்மையில் உறுதிசெய்யப்பட்ட கட்டணத்தின் அடிப்படையில் சேவையகத்தால் கணக்கிடப்பட்டு உறுதிசெய்யப்படுகிறது.",
  "panel.preparing": "தயார் செய்கிறது …",
  "panel.continueWith": "{provider} உடன் தொடரவும்",
  "panel.choosePaymentMethod": "ஒரு கட்டண முறையைத் தேர்ந்தெடுக்கவும்",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME அமைக்கப்படவில்லை - கட்டமைப்பிற்கு README ஐப் பார்க்கவும்.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID அமைக்கப்படவில்லை - கட்டமைப்பிற்கு README ஐப் பார்க்கவும்.",

  "panel.paypalAmountInfo": "தொகை: {amount} (மதிப்பிடப்பட்ட {clicks} கிளிக்குகள்). கீழே உள்ள PayPal பொத்தானுடன் கட்டணத்தை முடிக்கவும்.",
  "panel.back": "← பின் செல்",

  "panel.bmcWarningTitle": "⚠️ BuyMeCoffee-க்குச் செல்வதற்கு முன்:",
  "panel.bmcWarningBody":
    "செக்அவுட்டின் போது கீழே உள்ள குறியீட்டை செய்தி/குறிப்பு புலத்தில் ஒட்டவும் — நீங்கள் எந்த நாட்டிற்கு ஆதரவு அளிக்கிறீர்கள் என்பதை அறிய இதுவே ஒரே வழி. குறியீடு இல்லாமல், கட்டணத்தை எந்த நாட்டிற்கும் நாங்கள் இணைக்க முடியாது.",
  "panel.copy": "நகலெடு",
  "panel.copied": "நகலெடுக்கப்பட்டது ✓",
  "panel.suggestedAmount": "பரிந்துரைக்கப்பட்ட தொகை:",
  "panel.bmcAmountNote":
    "(மதிப்பிடப்பட்ட {clicks} கிளிக்குகள்). துரதிர்ஷ்டவசமாக BuyMeCoffee இணைப்பு வழியாக தொகையைக் கொண்டு செல்வதை ஆதரிக்காது — அவர்களின் தளத்தில் நீங்களே அதை உள்ளிடவும்/தேர்ந்தெடுக்கவும். உண்மையான கிளிக் எண்ணிக்கை எப்போதும் நீங்கள் BuyMeCoffee-இல் உண்மையில் அனுப்பும் தொகையிலிருந்து கணக்கிடப்படும், இந்த மதிப்பீட்டிலிருந்து அல்ல.",
  "panel.openBmc": "BuyMeCoffee ஐத் திறந்து தொடரவும் →",
  "panel.waitingProvider": "கட்டண வழங்குநரிடமிருந்து கட்டண உறுதிப்படுத்தலுக்காகக் காத்திருக்கிறது …",
  "panel.waitingConfirmation": "கட்டண உறுதிப்படுத்தலுக்காகக் காத்திருக்கிறது …",
  "panel.timedOut":
    "சரிபார்ப்பு நேரம் முடிந்தது. கட்டணத்தை நீங்கள் முடித்திருந்தால், சேவையகம் உறுதிப்படுத்தலைப் பெற்றவுடன் வரைபடம் புதுப்பிக்கப்படும் - இதற்கு சில நேரங்களில் இன்னும் சிறிது நேரம் ஆகலாம்.",
  "panel.checkAgain": "மீண்டும் சரிபார்",

  "panel.cancelled": "கட்டணம் ரத்து செய்யப்பட்டது அல்லது முடிவடையவில்லை. வரைபடம் மாறவில்லை.",
  "panel.tryAgain": "மீண்டும் முயற்சிக்கவும்",

  "panel.confirmed": "✅ ஆதரவு உறுதிசெய்யப்பட்டது!",
  "panel.confirmedBody": "{country} க்கு {amount} க்கு {clicks} கட்டண கிளிக்குகள் கிடைத்தன.",

  "panel.errorPreparingSupport": "உங்கள் ஆதரவைத் தயாரிப்பதில் பிழை.",
  "panel.errorPreparingPayment": "கட்டணத்தைத் தயாரிப்பதில் பிழை.",
  "panel.errorConfirmingPayment": "கட்டணத்தை உறுதிப்படுத்துவதில் பிழை.",
  "panel.errorPayingPaypal": "PayPal மூலம் செலுத்துவதில் பிழை.",

  "share.unranked": "{flag}{country}-க்கு உலக வரைபடத்தில் உங்கள் ஆதரவு தேவை!\nதரவரிசைப் பட்டியலில் ஏற உதவுங்கள் 👇",
  "share.rank1": "{flag}{country} தற்போது #1 இல் உள்ளது!\nமுதலிடத்தில் இருக்க எங்களுக்கு உதவுங்கள் 👇",
  "share.rankN": "{flag}{country} தற்போது #{rank} இல் உள்ளது!\n#1 ஐ அடைய எங்களுக்கு உதவுங்கள் 👇",

  "language.switcherLabel": "மொழி",
};

export default ta;
